export default function About() {
  const values = [
    {
      icon: "ri-emotion-happy-line",
      title: "只推好笑的",
      desc: "每一部下饭神番都经过口碑筛选，笑点密度拉满，不让你踩坑。",
    },
    {
      icon: "ri-magic-line",
      title: "分类够清楚",
      desc: "搞笑番、沙雕动画、解压日常、治愈番，按心情轻松选。",
    },
    {
      icon: "ri-fire-line",
      title: "紧跟热点",
      desc: "当季热门搞笑番第一时间整理，追更更方便，不怕错过。",
    },
    {
      icon: "ri-heart-3-line",
      title: "专治不开心",
      desc: "解压爆笑日常帮你看完心情舒畅，治愈疲惫的每一天。",
    },
  ];

  return (
    <section id="about" className="bg-background-100 py-14 md:py-20">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center">
          {/* image */}
          <div className="relative">
            <div className="rounded-3xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Cute%20orange%20cartoon%20puppy%20sitting%20with%20a%20bowl%20of%20food%20and%20a%20tv%20remote%2C%20watching%20comedy%20anime%20and%20laughing%2C%20warm%20cozy%20home%20scene%2C%20flat%20vector%20illustration%2C%20warm%20orange%20and%20cream%20palette%2C%20soft%20lighting%2C%20heartwarming%20fun%20atmosphere&width=900&height=760&seq=xgkp-about&orientation=portrait"
                alt="小狗看番吉祥物 - 一只边看番边干饭的快乐小狗"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -bottom-4 -left-2 md:-left-4 rounded-2xl bg-primary-500 text-background-50 px-4 py-3 shadow-soft">
              <div className="font-heading text-xl">小狗看番</div>
              <div className="text-xs text-background-100 mt-0.5">把快乐神番带给你</div>
            </div>
          </div>

          {/* text */}
          <div>
            <span className="inline-flex items-center gap-1.5 text-primary-600 font-bold text-sm">
              <i className="ri-pen-nib-line text-lg"></i>
              关于小狗看番
            </span>
            <h2 className="mt-2 font-heading text-2xl md:text-4xl text-foreground-900 leading-tight">
              让每一顿饭，都有下饭神番相伴
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              小狗看番诞生于一群重度追番用户的日常：吃饭时总找不到好笑的番，工作完只想无脑乐呵。
              于是我们决定做一件简单的事——把搞笑番推荐、沙雕动画和解压爆笑日常都汇聚到一起，
              让每个人都能在最短时间内找到对味的下饭神番。
            </p>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
              我们坚持“内容够真实、笑点够密集、分类够清楚”的原则，用心整理每一部神番，
              陪你从干饭到入眠，把不开心的日常统统笑掉。
            </p>

            <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4">
              {values.map((v) => (
                <div
                  key={v.title}
                  className="bg-background-50 rounded-2xl p-4 md:p-5 flex gap-3"
                >
                  <span className="w-10 h-10 shrink-0 rounded-xl bg-accent-100 text-accent-700 flex items-center justify-center">
                    <i className={`${v.icon} text-xl`}></i>
                  </span>
                  <div>
                    <div className="font-bold text-foreground-900 text-sm md:text-base">
                      {v.title}
                    </div>
                    <div className="mt-1 text-xs text-foreground-600 leading-relaxed">
                      {v.desc}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}